import './DynaButton.scss';
import PropTypes from "prop-types";

const DynaButton = (props) => {

  return (
    <button  {...props}>
      {props.children}
    </button>
  );
};

DynaButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string,
  id: PropTypes.string,
  key: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.any
}

export default DynaButton;